// extracted by mini-css-extract-plugin
export var textInput = "_ko-0";